import { render } from "./PolicyRequire.vue?vue&type=template&id=1919f02e&scoped=true"
import script from "./PolicyRequire.vue?vue&type=script&lang=js"
export * from "./PolicyRequire.vue?vue&type=script&lang=js"

import "./PolicyRequire.vue?vue&type=style&index=0&id=1919f02e&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1919f02e"]])

export default __exports__